import { Component } from '@angular/core';


@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: [ './sidebar-menu-item/sidebar-menu-item.component.scss' ],
})
export class SidebarMenuComponent { }
